import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';


interface PhoneFieldProps {
  control: Control<FormProps>;
}

export function PhoneField({ control }: Readonly<PhoneFieldProps>) {
  return (

      <Controller
        name="phone"
        control={control}
        render={({ field: { onChange, ...field } }) => (
          <TextField
            {...field}
            label="Phone"
            fullWidth
            type="tel"
            inputMode="numeric"
            autoComplete="tel"
            onChange={(e) => onChange(e.target.value.replace(/\D+/g, ''))}
          />
        )}
      />
 
  );
}
